module.exports = __webpack_public_path__ + "static/media/lightbulb.14bc88d5.png";